import { useSelector } from 'react-redux';

const useIsLearningTrainer = () => {
  const user = useSelector((state) => state.authSlice?.userData);
  return user?.learningRoles?.includes('TRAINER') || false;
};

export default useIsLearningTrainer;
// example usage
